import { DocumentPaymentsList } from "@/models/api/documents/DocumentPaymentsList";

export default [
  {
    id: 618483,
    createDate: "05.02.2021",
    amount: 1369.35,
    amountInCurrency: 1369.35,
    amountInDocumentCurrency: 1369.35,
    formOfPaymentName: "PayPal",
    formOfPaymentId: 17,
    exchangeDate: "2021-02-04T00:00:00",
    paymentDate: "05.02.2021",
    description: null,
    documentNumber: null,
    linkDocumentNumbers: null,
    currency: "PLN",
    documentId: "1c07337f-5abd-4313-9360-4b8566615e71",
    cashboxId: 1,
    recordStampId: 0,
  },
] as DocumentPaymentsList;
